import { render, staticRenderFns } from "./LConfirmDeleteDialog.vue?vue&type=template&id=37ee5509&scoped=true"
import script from "./LConfirmDeleteDialog.vue?vue&type=script&lang=js"
export * from "./LConfirmDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ee5509",
  null
  
)

export default component.exports